// src/secure/components/Nav.tsx (or your actual path)
import React, { Component, MouseEvent } from "react";
import axios from "axios";
import { Link, Redirect } from "react-router-dom";
import { User } from "../../classes/user";
import { connect } from "react-redux";

class Nav extends Component<{ user: User }> {
    state = {
        redirect: false,
    };

    handleClick = async (e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        try {
            // Tell server to end the session/cookie if you use one
            await axios.post("logout/", {}, { withCredentials: true });
        } catch (err) {
            // swallow errors - we still want to clear client state
        }

        // 🔑 Critical: clear client-side auth so PrivateRoute blocks /dashboard
        localStorage.removeItem("token");
        localStorage.removeItem("auth"); // or setItem('auth','false')

        // Redirect to /login (route is public-only in App.tsx)
        this.setState({ redirect: true });
    };

    render() {
        if (this.state.redirect) {
            return <Redirect to="/login" />;
        }

        return (
            <nav className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
                <a
                    className="navbar-brand col-md-3 col-lg-2 mr-0 px-3"
                    href="#"
                    onClick={(e) => e.preventDefault()}
                >
                    Science Technology Innovation Indicators
                </a>
                <ul className="my-2 my-md-0 mr-md-3">
                    <Link to={"/profile"} className="p-2 text-white">
                        {this.props.user.name}
                    </Link>
                    <a className="p-2 text-white" href="#" onClick={this.handleClick}>
                        Sign out
                    </a>
                </ul>
            </nav>
        );
    }
}

// @ts-ignore
export default connect((state) => ({ user: state.user }))(Nav);
